@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(-620_310_452)
internal val Res.string.probe_unavailable_title: StringResource by lazy {
      StringResource("string:probe_unavailable_title", "probe_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37769, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38085, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37525, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35409, 59),
      ))
    }

@delegate:ResourceContentHash(2_126_830_929)
internal val Res.string.probe_unpaid_note: StringResource by lazy {
      StringResource("string:probe_unpaid_note", "probe_unpaid_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37845, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38153, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37597, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35469, 53),
      ))
    }

@delegate:ResourceContentHash(164_251_685)
internal val Res.string.probe_valid_until: StringResource by lazy {
      StringResource("string:probe_valid_until", "probe_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37895, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38211, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37659, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35523, 49),
      ))
    }

@delegate:ResourceContentHash(1_280_305_994)
internal val Res.string.project_impacts_label: StringResource by lazy {
      StringResource("string:project_impacts_label", "project_impacts_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37949, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38265, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37709, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35573, 49),
      ))
    }

@delegate:ResourceContentHash(187_209_174)
internal val Res.string.project_incidence_pct: StringResource by lazy {
      StringResource("string:project_incidence_pct", "project_incidence_pct", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37999, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38315, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37759, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35623, 53),
      ))
    }

@delegate:ResourceContentHash(520_663_360)
internal val Res.string.project_max_detected: StringResource by lazy {
      StringResource("string:project_max_detected", "project_max_detected", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38053, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38369, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37817, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35677, 44),
      ))
    }

@delegate:ResourceContentHash(757_136_141)
internal val Res.string.project_max_impact: StringResource by lazy {
      StringResource("string:project_max_impact", "project_max_impact", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38102, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38418, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37866, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35722, 50),
      ))
    }

@delegate:ResourceContentHash(-942_811_822)
internal val Res.string.project_monthly_activity: StringResource by lazy {
      StringResource("string:project_monthly_activity", "project_monthly_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38157, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38469, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37921, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35773, 56),
      ))
    }

@delegate:ResourceContentHash(-2_131_451_113)
internal val Res.string.project_named: StringResource by lazy {
      StringResource("string:project_named", "project_named", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38214, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38530, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37978, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35830, 37),
      ))
    }

@delegate:ResourceContentHash(-641_918_299)
internal val Res.string.project_polarity: StringResource by lazy {
      StringResource("string:project_polarity", "project_polarity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38256, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38568, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38016, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35868, 36),
      ))
    }

@delegate:ResourceContentHash(-1_096_147_601)
internal val Res.string.project_top_impacts: StringResource by lazy {
      StringResource("string:project_top_impacts", "project_top_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38293, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38605, 79),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38057, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35905, 75),
      ))
    }

@delegate:ResourceContentHash(1_757_018_691)
internal val Res.string.projects_action_map: StringResource by lazy {
      StringResource("string:projects_action_map", "projects_action_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38381, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38685, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38145, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35981, 43),
      ))
    }

@delegate:ResourceContentHash(-1_334_055_556)
internal val Res.string.projects_action_report: StringResource by lazy {
      StringResource("string:projects_action_report", "projects_action_report", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38425, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38733, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38189, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36025, 46),
      ))
    }

@delegate:ResourceContentHash(1_632_475_567)
internal val Res.string.projects_all_probes: StringResource by lazy {
      StringResource("string:projects_all_probes", "projects_all_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38472, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38780, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38240, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36072, 43),
      ))
    }

@delegate:ResourceContentHash(1_494_068_239)
internal val Res.string.projects_count: StringResource by lazy {
      StringResource("string:projects_count", "projects_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38524, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38832, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38288, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36116, 42),
      ))
    }

@delegate:ResourceContentHash(2_070_313_127)
internal val Res.string.projects_created_on: StringResource by lazy {
      StringResource("string:projects_created_on", "projects_created_on", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38571, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38875, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38331, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36159, 47),
      ))
    }

@delegate:ResourceContentHash(292_679_478)
internal val Res.string.projects_filter_all: StringResource by lazy {
      StringResource("string:projects_filter_all", "projects_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38619, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38923, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38379, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36207, 31),
      ))
    }

@delegate:ResourceContentHash(-1_649_173_559)
internal val Res.string.projects_filter_no_impact: StringResource by lazy {
      StringResource("string:projects_filter_no_impact", "projects_filter_no_impact", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38655, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 38959, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38415, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36239, 45),
      ))
    }

@delegate:ResourceContentHash(-341_989_604)
internal val Res.string.projects_name: StringResource by lazy {
      StringResource("string:projects_name", "projects_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38705, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39009, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38465, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36285, 41),
      ))
    }

@delegate:ResourceContentHash(-341_937_286)
internal val Res.string.projects_no_incidence: StringResource by lazy {
      StringResource("string:projects_no_incidence", "projects_no_incidence", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38755, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39051, 89),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38507, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36327, 85),
      ))
    }

@delegate:ResourceContentHash(885_566_371)
internal val Res.string.projects_search_hint: StringResource by lazy {
      StringResource("string:projects_search_hint", "projects_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38841, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39141, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38597, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36413, 56),
      ))
    }

@delegate:ResourceContentHash(473_489_063)
internal val Res.string.projects_sort_created: StringResource by lazy {
      StringResource("string:projects_sort_created", "projects_sort_created", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38898, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39202, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38658, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36470, 53),
      ))
    }

@delegate:ResourceContentHash(1_266_582_148)
internal val Res.string.projects_sort_impacts: StringResource by lazy {
      StringResource("string:projects_sort_impacts", "projects_sort_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 38960, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39260, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38720, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36524, 53),
      ))
    }

@delegate:ResourceContentHash(-2_105_794_931)
internal val Res.string.projects_sort_last_alert: StringResource by lazy {
      StringResource("string:projects_sort_last_alert", "projects_sort_last_alert", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39018, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39318, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38778, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36578, 60),
      ))
    }

@delegate:ResourceContentHash(-1_549_762_120)
internal val Res.string.projects_sort_name: StringResource by lazy {
      StringResource("string:projects_sort_name", "projects_sort_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39087, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39391, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38847, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36639, 50),
      ))
    }

@delegate:ResourceContentHash(-561_126_430)
internal val Res.string.projects_summary_1km: StringResource by lazy {
      StringResource("string:projects_summary_1km", "projects_summary_1km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39142, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39442, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38902, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36690, 48),
      ))
    }

@delegate:ResourceContentHash(-1_458_185_182)
internal val Res.string.projects_summary_2km: StringResource by lazy {
      StringResource("string:projects_summary_2km", "projects_summary_2km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39191, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39491, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 38951, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36739, 48),
      ))
    }

@delegate:ResourceContentHash(-91_516_257)
internal val Res.string.projects_summary_total: StringResource by lazy {
      StringResource("string:projects_summary_total", "projects_summary_total", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39240, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39540, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39000, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36788, 50),
      ))
    }

@delegate:ResourceContentHash(-822_111_342)
internal val Res.string.promo_action_delete: StringResource by lazy {
      StringResource("string:promo_action_delete", "promo_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39291, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39587, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39051, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36839, 35),
      ))
    }

@delegate:ResourceContentHash(669_396_631)
internal val Res.string.promo_action_disable: StringResource by lazy {
      StringResource("string:promo_action_disable", "promo_action_disable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39331, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39627, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39091, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36875, 40),
      ))
    }

@delegate:ResourceContentHash(2_069_807_681)
internal val Res.string.promo_action_edit: StringResource by lazy {
      StringResource("string:promo_action_edit", "promo_action_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39376, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39672, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39132, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36916, 33),
      ))
    }

@delegate:ResourceContentHash(436_257_832)
internal val Res.string.promo_action_enable: StringResource by lazy {
      StringResource("string:promo_action_enable", "promo_action_enable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39410, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39710, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39166, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36950, 35),
      ))
    }

@delegate:ResourceContentHash(-121_104_296)
internal val Res.string.promo_action_error: StringResource by lazy {
      StringResource("string:promo_action_error", "promo_action_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39450, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39754, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39206, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36986, 74),
      ))
    }

@delegate:ResourceContentHash(1_468_932_139)
internal val Res.string.promo_admin_count: StringResource by lazy {
      StringResource("string:promo_admin_count", "promo_admin_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39537, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39829, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39277, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37061, 49),
      ))
    }

@delegate:ResourceContentHash(758_244_465)
internal val Res.string.promo_admin_edit_title: StringResource by lazy {
      StringResource("string:promo_admin_edit_title", "promo_admin_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39591, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39883, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39331, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37111, 50),
      ))
    }

@delegate:ResourceContentHash(-426_984_094)
internal val Res.string.promo_admin_empty: StringResource by lazy {
      StringResource("string:promo_admin_empty", "promo_admin_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39662, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39946, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39402, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37162, 49),
      ))
    }

@delegate:ResourceContentHash(242_028_830)
internal val Res.string.promo_admin_load_error: StringResource by lazy {
      StringResource("string:promo_admin_load_error", "promo_admin_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39748, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40020, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39484, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37212, 74),
      ))
    }

@delegate:ResourceContentHash(1_403_760_082)
internal val Res.string.promo_admin_new: StringResource by lazy {
      StringResource("string:promo_admin_new", "promo_admin_new", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39909, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40157, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39649, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37337, 35),
      ))
    }

@delegate:ResourceContentHash(878_297_970)
internal val Res.string.promo_admin_new_title: StringResource by lazy {
      StringResource("string:promo_admin_new_title", "promo_admin_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39843, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40103, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39587, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37287, 49),
      ))
    }

@delegate:ResourceContentHash(1_853_200_797)
internal val Res.string.promo_admin_no_match: StringResource by lazy {
      StringResource("string:promo_admin_no_match", "promo_admin_no_match", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 39953, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40197, 84),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39689, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37373, 64),
      ))
    }

@delegate:ResourceContentHash(1_852_696_976)
internal val Res.string.promo_admin_search_hint: StringResource by lazy {
      StringResource("string:promo_admin_search_hint", "promo_admin_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40038, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40282, 95),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39770, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37438, 75),
      ))
    }

@delegate:ResourceContentHash(820_100_177)
internal val Res.string.promo_benefit_free: StringResource by lazy {
      StringResource("string:promo_benefit_free", "promo_benefit_free", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40130, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40378, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39866, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37514, 46),
      ))
    }

@delegate:ResourceContentHash(631_198_722)
internal val Res.string.promo_benefit_months: StringResource by lazy {
      StringResource("string:promo_benefit_months", "promo_benefit_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40286, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40534, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40026, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37666, 52),
      ))
    }

@delegate:ResourceContentHash(1_492_362_819)
internal val Res.string.promo_benefit_months_percent: StringResource by lazy {
      StringResource("string:promo_benefit_months_percent", "promo_benefit_months_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40181, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40429, 104),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 39917, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37561, 104),
      ))
    }

@delegate:ResourceContentHash(2_141_967_604)
internal val Res.string.promo_benefit_none: StringResource by lazy {
      StringResource("string:promo_benefit_none", "promo_benefit_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40339, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40587, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40079, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37719, 42),
      ))
    }

@delegate:ResourceContentHash(-74_402_661)
internal val Res.string.promo_benefit_percent: StringResource by lazy {
      StringResource("string:promo_benefit_percent", "promo_benefit_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40386, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40634, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40130, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37762, 65),
      ))
    }

@delegate:ResourceContentHash(1_314_784_965)
internal val Res.string.promo_cancel: StringResource by lazy {
      StringResource("string:promo_cancel", "promo_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40452, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40704, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40192, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37828, 28),
      ))
    }

@delegate:ResourceContentHash(469_445_692)
internal val Res.string.promo_commission_line: StringResource by lazy {
      StringResource("string:promo_commission_line", "promo_commission_line", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40485, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40737, 97),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40225, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37857, 101),
      ))
    }

@delegate:ResourceContentHash(-1_634_409_372)
internal val Res.string.promo_delete_body_unused: StringResource by lazy {
      StringResource("string:promo_delete_body_unused", "promo_delete_body_unused", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40591, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40835, 124),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40335, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37959, 96),
      ))
    }

@delegate:ResourceContentHash(1_943_571_195)
internal val Res.string.promo_delete_body_used: StringResource by lazy {
      StringResource("string:promo_delete_body_used", "promo_delete_body_used", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40936, 278),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41184, 286),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40664, 270),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38264, 250),
      ))
    }

@delegate:ResourceContentHash(1_658_085_495)
internal val Res.string.promo_delete_body_used_disabled: StringResource by lazy {
      StringResource("string:promo_delete_body_used_disabled", "promo_delete_body_used_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 40712, 223),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 40960, 223),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40448, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38056, 207),
      ))
    }

@delegate:ResourceContentHash(-822_111_342)
internal val Res.string.promo_delete_confirm: StringResource by lazy {
      StringResource("string:promo_delete_confirm", "promo_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41283, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41535, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40999, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38571, 36),
      ))
    }

@delegate:ResourceContentHash(490_828_223)
internal val Res.string.promo_delete_confirm_anyway: StringResource by lazy {
      StringResource("string:promo_delete_confirm_anyway", "promo_delete_confirm_anyway", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41215, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41471, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 40935, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38515, 55),
      ))
    }

@delegate:ResourceContentHash(-1_095_732_819)
internal val Res.string.promo_delete_disable_instead: StringResource by lazy {
      StringResource("string:promo_delete_disable_instead", "promo_delete_disable_instead", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41324, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41576, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41040, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38608, 56),
      ))
    }

@delegate:ResourceContentHash(-991_255_778)
internal val Res.string.promo_delete_title: StringResource by lazy {
      StringResource("string:promo_delete_title", "promo_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41393, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41641, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41109, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38665, 54),
      ))
    }

@delegate:ResourceContentHash(434_404_833)
internal val Res.string.promo_err_already_used: StringResource by lazy {
      StringResource("string:promo_err_already_used", "promo_err_already_used", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41456, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41700, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41168, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38720, 74),
      ))
    }

@delegate:ResourceContentHash(188_364_372)
internal val Res.string.promo_err_code_invalid: StringResource by lazy {
      StringResource("string:promo_err_code_invalid", "promo_err_code_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41527, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41775, 126),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41243, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38795, 118),
      ))
    }

@delegate:ResourceContentHash(2_049_817_956)
internal val Res.string.promo_err_commission: StringResource by lazy {
      StringResource("string:promo_err_commission", "promo_err_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41749, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41997, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41469, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39013, 52),
      ))
    }

@delegate:ResourceContentHash(-2_121_374_183)
internal val Res.string.promo_err_commission_email: StringResource by lazy {
      StringResource("string:promo_err_commission_email", "promo_err_commission_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41654, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 41902, 94),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41378, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38914, 98),
      ))
    }

@delegate:ResourceContentHash(-1_905_657_386)
internal val Res.string.promo_err_date_invalid: StringResource by lazy {
      StringResource("string:promo_err_date_invalid", "promo_err_date_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41798, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42046, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41518, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39066, 66),
      ))
    }

@delegate:ResourceContentHash(-1_466_844_489)
internal val Res.string.promo_err_date_past: StringResource by lazy {
      StringResource("string:promo_err_date_past", "promo_err_date_past", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41869, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42113, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41589, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39133, 59),
      ))
    }

@delegate:ResourceContentHash(-1_673_465_608)
internal val Res.string.promo_err_email: StringResource by lazy {
      StringResource("string:promo_err_email", "promo_err_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 41929, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42177, 83),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41645, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39193, 75),
      ))
    }

@delegate:ResourceContentHash(-786_663_376)
internal val Res.string.promo_err_expired_user: StringResource by lazy {
      StringResource("string:promo_err_expired_user", "promo_err_expired_user", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42013, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42261, 90),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41725, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39269, 94),
      ))
    }

@delegate:ResourceContentHash(1_995_162_582)
internal val Res.string.promo_err_fix_fields: StringResource by lazy {
      StringResource("string:promo_err_fix_fields", "promo_err_fix_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42112, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42352, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41824, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39364, 60),
      ))
    }

@delegate:ResourceContentHash(86_549_189)
internal val Res.string.promo_err_max: StringResource by lazy {
      StringResource("string:promo_err_max", "promo_err_max", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42177, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42421, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41893, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39425, 89),
      ))
    }

@delegate:ResourceContentHash(-1_780_801_942)
internal val Res.string.promo_err_months: StringResource by lazy {
      StringResource("string:promo_err_months", "promo_err_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42263, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42503, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 41979, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39515, 48),
      ))
    }

@delegate:ResourceContentHash(-1_837_704_410)
internal val Res.string.promo_err_not_applicable: StringResource by lazy {
      StringResource("string:promo_err_not_applicable", "promo_err_not_applicable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42308, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42548, 100),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42024, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39564, 84),
      ))
    }

@delegate:ResourceContentHash(-544_303_631)
internal val Res.string.promo_err_not_found_user: StringResource by lazy {
      StringResource("string:promo_err_not_found_user", "promo_err_not_found_user", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42401, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42649, 92),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42121, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39649, 88),
      ))
    }

@delegate:ResourceContentHash(2_049_817_956)
internal val Res.string.promo_err_percent: StringResource by lazy {
      StringResource("string:promo_err_percent", "promo_err_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42502, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42742, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42226, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39738, 49),
      ))
    }

@delegate:ResourceContentHash(1_892_301_278)
internal val Res.string.promo_err_unavailable: StringResource by lazy {
      StringResource("string:promo_err_unavailable", "promo_err_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42548, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42788, 121),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42272, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39788, 101),
      ))
    }

@delegate:ResourceContentHash(-204_726_102)
internal val Res.string.promo_field_applied: StringResource by lazy {
      StringResource("string:promo_field_applied", "promo_field_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42674, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42910, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42398, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39890, 55),
      ))
    }

@delegate:ResourceContentHash(-1_488_090_433)
internal val Res.string.promo_field_apply: StringResource by lazy {
      StringResource("string:promo_field_apply", "promo_field_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42738, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42970, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42462, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39946, 33),
      ))
    }

@delegate:ResourceContentHash(-180_377_668)
internal val Res.string.promo_field_checking: StringResource by lazy {
      StringResource("string:promo_field_checking", "promo_field_checking", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42776, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43008, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42500, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39980, 44),
      ))
    }

@delegate:ResourceContentHash(771_642_488)
internal val Res.string.promo_field_label: StringResource by lazy {
      StringResource("string:promo_field_label", "promo_field_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42825, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43061, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42549, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40025, 53),
      ))
    }

@delegate:ResourceContentHash(1_467_040_862)
internal val Res.string.promo_field_placeholder: StringResource by lazy {
      StringResource("string:promo_field_placeholder", "promo_field_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42891, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43119, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42615, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40079, 47),
      ))
    }

@delegate:ResourceContentHash(57_127_224)
internal val Res.string.promo_field_remove: StringResource by lazy {
      StringResource("string:promo_field_remove", "promo_field_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42951, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43175, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42675, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40127, 34),
      ))
    }

@delegate:ResourceContentHash(292_679_478)
internal val Res.string.promo_filter_all: StringResource by lazy {
      StringResource("string:promo_filter_all", "promo_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 42986, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43214, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42714, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40162, 28),
      ))
    }

@delegate:ResourceContentHash(1_798_105_574)
internal val Res.string.promo_filter_app_all: StringResource by lazy {
      StringResource("string:promo_filter_app_all", "promo_filter_app_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43019, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43247, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42747, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40191, 40),
      ))
    }

@delegate:ResourceContentHash(264_032_837)
internal val Res.string.promo_form_active: StringResource by lazy {
      StringResource("string:promo_form_active", "promo_form_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43068, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43296, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42796, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40232, 33),
      ))
    }

@delegate:ResourceContentHash(-355_444_992)
internal val Res.string.promo_form_app: StringResource by lazy {
      StringResource("string:promo_form_app", "promo_form_app", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43196, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43404, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42916, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40348, 26),
      ))
    }

@delegate:ResourceContentHash(-1_062_876_314)
internal val Res.string.promo_form_app_locked: StringResource by lazy {
      StringResource("string:promo_form_app_locked", "promo_form_app_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43102, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43330, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42830, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40266, 81),
      ))
    }

@delegate:ResourceContentHash(-1_044_056_014)
internal val Res.string.promo_form_benefit: StringResource by lazy {
      StringResource("string:promo_form_benefit", "promo_form_benefit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43368, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43580, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43092, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40516, 50),
      ))
    }

@delegate:ResourceContentHash(1_848_630_446)
internal val Res.string.promo_form_benefit_both: StringResource by lazy {
      StringResource("string:promo_form_benefit_both", "promo_form_benefit_both", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43223, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43431, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42943, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40375, 39),
      ))
    }

@delegate:ResourceContentHash(-652_431_179)
internal val Res.string.promo_form_benefit_months: StringResource by lazy {
      StringResource("string:promo_form_benefit_months", "promo_form_benefit_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43263, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43475, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 42983, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40415, 49),
      ))
    }

@delegate:ResourceContentHash(-1_155_771_101)
internal val Res.string.promo_form_benefit_percent: StringResource by lazy {
      StringResource("string:promo_form_benefit_percent", "promo_form_benefit_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43313, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43525, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43037, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40465, 50),
      ))
    }

@delegate:ResourceContentHash(-1_348_937_752)
internal val Res.string.promo_form_code: StringResource by lazy {
      StringResource("string:promo_form_code", "promo_form_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43576, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43776, 31),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43292, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40692, 31),
      ))
    }

@delegate:ResourceContentHash(-753_702_660)
internal val Res.string.promo_form_code_help: StringResource by lazy {
      StringResource("string:promo_form_code_help", "promo_form_code_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43427, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43627, 148),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43151, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40567, 124),
      ))
    }

@delegate:ResourceContentHash(1_008_077_316)
internal val Res.string.promo_form_commission: StringResource by lazy {
      StringResource("string:promo_form_commission", "promo_form_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43715, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43895, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43427, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40815, 49),
      ))
    }

@delegate:ResourceContentHash(495_466_661)
internal val Res.string.promo_form_commission_help: StringResource by lazy {
      StringResource("string:promo_form_commission_help", "promo_form_commission_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43612, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43808, 86),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43328, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40724, 90),
      ))
    }

@delegate:ResourceContentHash(-908_751_596)
internal val Res.string.promo_form_end_date: StringResource by lazy {
      StringResource("string:promo_form_end_date", "promo_form_end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43875, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44055, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43583, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40967, 55),
      ))
    }

@delegate:ResourceContentHash(-685_936_027)
internal val Res.string.promo_form_end_date_help: StringResource by lazy {
      StringResource("string:promo_form_end_date_help", "promo_form_end_date_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43765, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43945, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43477, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40865, 60),
      ))
    }

@delegate:ResourceContentHash(-253_223_830)
internal val Res.string.promo_form_end_date_none: StringResource by lazy {
      StringResource("string:promo_form_end_date_none", "promo_form_end_date_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43830, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44010, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43538, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40926, 40),
      ))
    }

@delegate:ResourceContentHash(155_349_510)
internal val Res.string.promo_form_max: StringResource by lazy {
      StringResource("string:promo_form_max", "promo_form_max", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43984, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44160, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43688, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41068, 34),
      ))
    }

@delegate:ResourceContentHash(-340_096_228)
internal val Res.string.promo_form_max_unlimited: StringResource by lazy {
      StringResource("string:promo_form_max_unlimited", "promo_form_max_unlimited", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43939, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44115, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43643, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41023, 44),
      ))
    }

@delegate:ResourceContentHash(-652_431_179)
internal val Res.string.promo_form_months: StringResource by lazy {
      StringResource("string:promo_form_months", "promo_form_months", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44074, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44250, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43790, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41146, 41),
      ))
    }

@delegate:ResourceContentHash(-1_377_854_895)
internal val Res.string.promo_form_months_help: StringResource by lazy {
      StringResource("string:promo_form_months_help", "promo_form_months_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44027, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44207, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43743, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41103, 42),
      ))
    }

@delegate:ResourceContentHash(266_606_934)
internal val Res.string.promo_form_percent: StringResource by lazy {
      StringResource("string:promo_form_percent", "promo_form_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44248, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44424, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43964, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41312, 42),
      ))
    }

@delegate:ResourceContentHash(-824_280_524)
internal val Res.string.promo_form_percent_help: StringResource by lazy {
      StringResource("string:promo_form_percent_help", "promo_form_percent_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44116, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44292, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43836, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41188, 67),
      ))
    }

@delegate:ResourceContentHash(-874_329_611)
internal val Res.string.promo_form_percent_then: StringResource by lazy {
      StringResource("string:promo_form_percent_then", "promo_form_percent_then", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44188, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44364, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 43904, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41256, 55),
      ))
    }

@delegate:ResourceContentHash(545_127_101)
internal val Res.string.promo_form_preview: StringResource by lazy {
      StringResource("string:promo_form_preview", "promo_form_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44447, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44611, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44155, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41495, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("probe_unavailable_title", Res.string.probe_unavailable_title)
  map.put("probe_unpaid_note", Res.string.probe_unpaid_note)
  map.put("probe_valid_until", Res.string.probe_valid_until)
  map.put("project_impacts_label", Res.string.project_impacts_label)
  map.put("project_incidence_pct", Res.string.project_incidence_pct)
  map.put("project_max_detected", Res.string.project_max_detected)
  map.put("project_max_impact", Res.string.project_max_impact)
  map.put("project_monthly_activity", Res.string.project_monthly_activity)
  map.put("project_named", Res.string.project_named)
  map.put("project_polarity", Res.string.project_polarity)
  map.put("project_top_impacts", Res.string.project_top_impacts)
  map.put("projects_action_map", Res.string.projects_action_map)
  map.put("projects_action_report", Res.string.projects_action_report)
  map.put("projects_all_probes", Res.string.projects_all_probes)
  map.put("projects_count", Res.string.projects_count)
  map.put("projects_created_on", Res.string.projects_created_on)
  map.put("projects_filter_all", Res.string.projects_filter_all)
  map.put("projects_filter_no_impact", Res.string.projects_filter_no_impact)
  map.put("projects_name", Res.string.projects_name)
  map.put("projects_no_incidence", Res.string.projects_no_incidence)
  map.put("projects_search_hint", Res.string.projects_search_hint)
  map.put("projects_sort_created", Res.string.projects_sort_created)
  map.put("projects_sort_impacts", Res.string.projects_sort_impacts)
  map.put("projects_sort_last_alert", Res.string.projects_sort_last_alert)
  map.put("projects_sort_name", Res.string.projects_sort_name)
  map.put("projects_summary_1km", Res.string.projects_summary_1km)
  map.put("projects_summary_2km", Res.string.projects_summary_2km)
  map.put("projects_summary_total", Res.string.projects_summary_total)
  map.put("promo_action_delete", Res.string.promo_action_delete)
  map.put("promo_action_disable", Res.string.promo_action_disable)
  map.put("promo_action_edit", Res.string.promo_action_edit)
  map.put("promo_action_enable", Res.string.promo_action_enable)
  map.put("promo_action_error", Res.string.promo_action_error)
  map.put("promo_admin_count", Res.string.promo_admin_count)
  map.put("promo_admin_edit_title", Res.string.promo_admin_edit_title)
  map.put("promo_admin_empty", Res.string.promo_admin_empty)
  map.put("promo_admin_load_error", Res.string.promo_admin_load_error)
  map.put("promo_admin_new", Res.string.promo_admin_new)
  map.put("promo_admin_new_title", Res.string.promo_admin_new_title)
  map.put("promo_admin_no_match", Res.string.promo_admin_no_match)
  map.put("promo_admin_search_hint", Res.string.promo_admin_search_hint)
  map.put("promo_benefit_free", Res.string.promo_benefit_free)
  map.put("promo_benefit_months", Res.string.promo_benefit_months)
  map.put("promo_benefit_months_percent", Res.string.promo_benefit_months_percent)
  map.put("promo_benefit_none", Res.string.promo_benefit_none)
  map.put("promo_benefit_percent", Res.string.promo_benefit_percent)
  map.put("promo_cancel", Res.string.promo_cancel)
  map.put("promo_commission_line", Res.string.promo_commission_line)
  map.put("promo_delete_body_unused", Res.string.promo_delete_body_unused)
  map.put("promo_delete_body_used", Res.string.promo_delete_body_used)
  map.put("promo_delete_body_used_disabled", Res.string.promo_delete_body_used_disabled)
  map.put("promo_delete_confirm", Res.string.promo_delete_confirm)
  map.put("promo_delete_confirm_anyway", Res.string.promo_delete_confirm_anyway)
  map.put("promo_delete_disable_instead", Res.string.promo_delete_disable_instead)
  map.put("promo_delete_title", Res.string.promo_delete_title)
  map.put("promo_err_already_used", Res.string.promo_err_already_used)
  map.put("promo_err_code_invalid", Res.string.promo_err_code_invalid)
  map.put("promo_err_commission", Res.string.promo_err_commission)
  map.put("promo_err_commission_email", Res.string.promo_err_commission_email)
  map.put("promo_err_date_invalid", Res.string.promo_err_date_invalid)
  map.put("promo_err_date_past", Res.string.promo_err_date_past)
  map.put("promo_err_email", Res.string.promo_err_email)
  map.put("promo_err_expired_user", Res.string.promo_err_expired_user)
  map.put("promo_err_fix_fields", Res.string.promo_err_fix_fields)
  map.put("promo_err_max", Res.string.promo_err_max)
  map.put("promo_err_months", Res.string.promo_err_months)
  map.put("promo_err_not_applicable", Res.string.promo_err_not_applicable)
  map.put("promo_err_not_found_user", Res.string.promo_err_not_found_user)
  map.put("promo_err_percent", Res.string.promo_err_percent)
  map.put("promo_err_unavailable", Res.string.promo_err_unavailable)
  map.put("promo_field_applied", Res.string.promo_field_applied)
  map.put("promo_field_apply", Res.string.promo_field_apply)
  map.put("promo_field_checking", Res.string.promo_field_checking)
  map.put("promo_field_label", Res.string.promo_field_label)
  map.put("promo_field_placeholder", Res.string.promo_field_placeholder)
  map.put("promo_field_remove", Res.string.promo_field_remove)
  map.put("promo_filter_all", Res.string.promo_filter_all)
  map.put("promo_filter_app_all", Res.string.promo_filter_app_all)
  map.put("promo_form_active", Res.string.promo_form_active)
  map.put("promo_form_app", Res.string.promo_form_app)
  map.put("promo_form_app_locked", Res.string.promo_form_app_locked)
  map.put("promo_form_benefit", Res.string.promo_form_benefit)
  map.put("promo_form_benefit_both", Res.string.promo_form_benefit_both)
  map.put("promo_form_benefit_months", Res.string.promo_form_benefit_months)
  map.put("promo_form_benefit_percent", Res.string.promo_form_benefit_percent)
  map.put("promo_form_code", Res.string.promo_form_code)
  map.put("promo_form_code_help", Res.string.promo_form_code_help)
  map.put("promo_form_commission", Res.string.promo_form_commission)
  map.put("promo_form_commission_help", Res.string.promo_form_commission_help)
  map.put("promo_form_end_date", Res.string.promo_form_end_date)
  map.put("promo_form_end_date_help", Res.string.promo_form_end_date_help)
  map.put("promo_form_end_date_none", Res.string.promo_form_end_date_none)
  map.put("promo_form_max", Res.string.promo_form_max)
  map.put("promo_form_max_unlimited", Res.string.promo_form_max_unlimited)
  map.put("promo_form_months", Res.string.promo_form_months)
  map.put("promo_form_months_help", Res.string.promo_form_months_help)
  map.put("promo_form_percent", Res.string.promo_form_percent)
  map.put("promo_form_percent_help", Res.string.promo_form_percent_help)
  map.put("promo_form_percent_then", Res.string.promo_form_percent_then)
  map.put("promo_form_preview", Res.string.promo_form_preview)
}
